var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    { class: `btn-note ${_vm.customClass}`, on: { click: _vm.handleClick } },
    [_vm._v("\n  " + _vm._s(_vm.content) + "\n")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }